module.exports = __webpack_public_path__ + "static/media/claude-bernard-logo.898dbfaf.png";